import ProductImage1 from '../images/Antibiotic-Powder-Bottles.jpg';
import ProductImage2 from '../images/Bronchodilator-Syrup.jpg';
import ProductImage3 from '../images/Expectorant-Syrup.jpg';
import ProductImage4 from '../images/Corroborant-Supplements.jpg';
import ProductImage5 from '../images/Digestive-Medications.jpg';
import ProductImage6 from '../images/Respiratory-Function-Test-Device.jpg';
import ProductImage7 from '../images/Laboratory-Testing-Equipment.jpg';
import ProductImage8 from '../images/Ophthalmic-Instruments.jpg';
import ProductImage9 from '../images/Ophthalmic-Tools.jpg';
import ProductImage10 from '../images/Ophthalmic-Supplies.jpg';

const productData = [
  {
    id: 1,
    title: 'Antibiotic Powder Bottles',
    category: 'Pharmaceuticals for Pediatrics',
    detailsLink: '/products/antibiotic-powder',
    imageUrl: ProductImage1,
  },
  {
    id: 2,
    title: 'Bronchodilator Syrup',
    category: 'Pharmaceuticals for Pediatrics',
    detailsLink: '/products/bronchodilator-syrup',
    imageUrl: ProductImage2,
  },
  {
    id: 3,
    title: 'Expectorant Syrup',
    category: 'Pharmaceuticals for Pediatrics',
    detailsLink: '/products/expectorant-syrup',
    imageUrl: ProductImage3,
  },
  {
    id: 4,
    title: 'Corroborant Supplements',
    category: 'Pharmaceuticals for Pediatrics',
    detailsLink: '/products/corroborant-supplements',
    imageUrl: ProductImage4,
  },
  {
    id: 5,
    title: 'Digestive Medications',
    category: 'Pharmaceuticals for Pediatrics',
    detailsLink: '/products/digestive-medications',
    imageUrl: ProductImage5,
  },
  {
    id: 6,
    title: 'Respiratory Function Test Device',
    category: 'Medical Equipment',
    detailsLink: '/products/respiratory-function-test',
    imageUrl: ProductImage6,
  },
  {
    id: 7,
    title: 'Laboratory Testing Equipment',
    category: 'Medical Equipment',
    detailsLink: '/products/lab-testing-equipment',
    imageUrl: ProductImage7,
  },
  {
    id: 8,
    title: 'Ophthalmic Instruments',
    category: 'Medical Equipment',
    detailsLink: '/products/ophthalmic-instruments',
    imageUrl: ProductImage8,
  },
  {
    id: 9,
    title: 'Ophthalmic Tools',
    category: 'Medical Equipment',
    detailsLink: '/products/ophthalmic-tools',
    imageUrl: ProductImage9,
  },
  {
    id: 10,
    title: 'Ophthalmic Supplies',
    category: 'Medical Equipment',
    detailsLink: '/products/ophthalmic-supplies',
    imageUrl: ProductImage10,
  },
  // Add more product data here
];

export default productData;